module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_null.33bc2b90.png";